
export function AboutDoctor() {
  return (
    <section id="about-doctor" aria-labelledby="doctor-heading" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="relative flex justify-center">
            <div className="absolute -top-6 -right-6 w-72 h-72 bg-teal-500/10 rounded-full -z-10"></div>
            <div
              className="absolute -bottom-6 -left-6 w-48 h-48 rounded-full -z-10"
              style={{ background: "rgba(255,107,107,0.1)" }}
            ></div>
            <div className="rounded-3xl overflow-hidden shadow-2xl w-[400px] h-[480px] relative">
              <img
                src="https://static.readdy.ai/image/4c54787fd2047152d108467e5113439e/2ecac460351113ce6c5e1985a64a46fb.png"
                alt="Dr. Kavitha Samanthula BDS - Lead Dentist at Sri Maruthi Teeth Empire, Kondapur Hyderabad"
                title="Dr. Kavitha Samanthula - Best Dentist in Kondapur Hyderabad"
                width="400"
                height="480"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                <div className="text-white">
                  <p
                    className="text-lg font-bold"
                    style={{ fontFamily: "Playfair Display, serif" }}
                  >
                    Dr. Kavitha Samanthula
                  </p>
                  <p className="text-sm text-white/80">BDS | Lead Dentist</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="inline-block bg-teal-50 px-4 py-2 rounded-full mb-4">
              <span className="text-sm font-semibold text-teal-600">
                Meet Your Dentist in Kondapur
              </span>
            </div>

            <h2
              id="doctor-heading"
              className="text-4xl md:text-5xl font-bold mb-2 text-gray-900 leading-tight"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Dr. Kavitha Samanthula
            </h2>
            <p className="text-lg text-teal-600 font-semibold mb-6">Senior Cosmetic Dental Sugeon</p>

            <div className="space-y-4 text-gray-600 leading-relaxed mb-8">
              <p>
                With <strong>10 years of dedicated experience</strong> in
                dentistry, <strong>Dr. Kavitha Samanthula</strong> is the driving
                force behind <strong>Sri Maruthi Teeth Empire</strong>. Her passion for oral
                health and commitment to patient comfort have made her one of
                the most trusted dentists in{" "}
                <strong>Kondapur, Hyderabad</strong>.
              </p>
              <p>
                Dr. Kavitha specializes in a wide range of dental treatments
                including <strong>cosmetic dentistry, root canal therapy, dental
                implants, and preventive care</strong>. She stays updated with
                the latest advancements in dental science to provide her
                patients with the most effective and minimally invasive
                treatments available.
              </p>
              <p>
                Her gentle approach and ability to put patients at ease,
                especially those with dental anxiety, sets her apart. Dr.
                Kavitha believes in educating her patients about their oral
                health and empowering them to make informed decisions about
                their treatment.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-8">
              <div className="bg-white p-5 rounded-2xl shadow-md text-center border border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-full mx-auto mb-3">
                  <i className="ri-time-line text-xl text-teal-600" aria-hidden="true"></i>
                </div>
                <div className="text-2xl font-bold text-gray-900 mb-1">10+</div>
                <div className="text-xs text-gray-500">Years Experience</div>
              </div>
              <div className="bg-white p-5 rounded-2xl shadow-md text-center border border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-full mx-auto mb-3">
                  <i className="ri-user-smile-line text-xl text-teal-600" aria-hidden="true"></i>
                </div>
                <div className="text-2xl font-bold text-gray-900 mb-1">5000+</div>
                <div className="text-xs text-gray-500">Happy Patients</div>
              </div>
              <div className="bg-white p-5 rounded-2xl shadow-md text-center border border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-full mx-auto mb-3">
                  <i className="ri-award-line text-xl text-teal-600" aria-hidden="true"></i>
                </div>
                <div className="text-2xl font-bold text-gray-900 mb-1">BDS</div>
                <div className="text-xs text-gray-500">Qualified Dentist</div>
              </div>
            </div>

            <a
              href="#booking"
              aria-label="Book an appointment with Dr. Kavitha Samanthula at Sri Maruthi Teeth Empire"
              className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-3 rounded-md font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-check-line text-lg" aria-hidden="true"></i>
              Book Appointment with Dr. Kavitha
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
